import { getApi } from "./api_instance";

export const requestTable = async (
  {
    categoryId,
    registries,
    tokenType,
    page,
    pageSize = 10,
    searchQuery = "",
  },
  dispatch
) => {
  const queryParams = new URLSearchParams();

  queryParams.append("page", page);
  queryParams.append("pageSize", pageSize);
  queryParams.append("searchQuery", searchQuery);

  if (registries) {
    const regId =
      Array.isArray(registries)
        ? registries.map((id) => `"${id}"`).join(",")
        : `"${registries}"`;
    queryParams.append("registries", `[${regId}]`);
  }

  if (tokenType) {
    queryParams.append("tokenType", tokenType);
  }

  if (categoryId) {
    queryParams.append("categoryId", categoryId);
  }

  const apiUrl = `/projects/api/request/user?${queryParams.toString()}`;

  try {
    return await getApi({
      apiUrl,
      sendToken: true,
      dispatch,
    });
  } catch (error) {
    throw error;
  }
};
